import { BrandCaptionLowerThirdEntity } from "@common/domain";
import { createAction, props } from "@ngrx/store";
import {
  RoomBrandCaptionLowerThirdCreateVO,
  RoomBrandCaptionLowerThirdDeleteVO,
  RoomBrandCaptionLowerThirdUnUseVO,
  RoomBrandCaptionLowerThirdUpdateVO,
  RoomBrandCaptionLowerThirdUseVO
} from "@youm-front/room/domain";

export const roomBrandCaptionLowerThirdCreate = createAction(
  "[Room] Room Brand Caption Lower Third Create",
  props<{
    roomBrandCaptionLowerThirdCreateVO: RoomBrandCaptionLowerThirdCreateVO;
  }>()
);
export const roomBrandCaptionLowerThirdCreateSuccess = createAction(
  "[Room] Brand Caption Lower Third Create Success",
  props<{ brandCaptionLowerThird: BrandCaptionLowerThirdEntity }>()
);
export const roomBrandCaptionLowerThirdCreateFailure = createAction(
  "[Room] Room Brand Caption Lower Third Create Failure",
  props<{ error: string }>()
);

export const roomBrandCaptionLowerThirdDelete = createAction(
  "[Room] Room Brand Caption Lower Third Delete",
  props<{
    roomBrandCaptionLowerThirdDeleteVO: RoomBrandCaptionLowerThirdDeleteVO;
  }>()
);
export const roomBrandCaptionLowerThirdDeleteSuccess = createAction(
  "[Room] Room Brand Caption Lower Third Delete Success",
  props<{ brandCaptionLowerThird: BrandCaptionLowerThirdEntity }>()
);
export const roomBrandCaptionLowerThirdDeleteFailure = createAction(
  "[Room] Room Brand Caption Lower Third Delete Failure",
  props<{ error: string }>()
);

export const roomBrandCaptionLowerThirdUnUse = createAction(
  "[Room] Room Brand Caption Lower Third Un Use",
  props<{
    roomBrandCaptionLowerThirdUnUseVO: RoomBrandCaptionLowerThirdUnUseVO;
  }>()
);
export const roomBrandCaptionLowerThirdUnUseSuccess = createAction(
  "[Room] Room Brand Caption Lower Third Un Use Success",
  props<{ brandCaptionLowerThird: BrandCaptionLowerThirdEntity }>()
);
export const roomBrandCaptionLowerThirdUnUseFailure = createAction(
  "[Room] Room Brand Caption Lower Third Un Use Failure",
  props<{ error: string }>()
);

export const roomBrandCaptionLowerThirdUpdate = createAction(
  "[Room] Room Brand Caption Lower Third Update",
  props<{
    roomBrandCaptionLowerThirdUpdateVO: RoomBrandCaptionLowerThirdUpdateVO;
  }>()
);
export const roomBrandCaptionLowerThirdUpdateSuccess = createAction(
  "[Room] Room Brand Caption Lower Third Update Success",
  props<{ brandCaptionLowerThird: BrandCaptionLowerThirdEntity }>()
);
export const roomBrandCaptionLowerThirdUpdateFailure = createAction(
  "[Room] Room Brand Caption Lower Third Update Failure",
  props<{ error: string }>()
);

export const roomBrandCaptionLowerThirdUse = createAction(
  "[Room] Room Brand Caption Lower Third Use",
  props<{ roomBrandCaptionLowerThirdUseVO: RoomBrandCaptionLowerThirdUseVO }>()
);
export const roomBrandCaptionLowerThirdUseSuccess = createAction(
  "[Room] Room Brand Caption Lower Third Use Success",
  props<{ brandCaptionLowerThird: BrandCaptionLowerThirdEntity }>()
);
export const roomBrandCaptionLowerThirdUseFailure = createAction(
  "[Room] Room Brand Caption Lower Third Use Failure",
  props<{ error: string }>()
);
